/**
 * Fichiers image dans public/gems/ (sans les variantes win*).
 * Ordre = rareté / valeur marchande croissantes (moins précieuse → plus précieuse),
 * pour la collection et le futur tirage des récompenses coffre.
 * Références : pierres précieuses (diamant, rubis, émeraude, saphir), tanzanite
 * (gisement unique), spinelle/jade/péridot de qualité, vs lapis lazuli et quartz
 * courants (pierres abondantes, prix au carat faibles en grade commercial).
 */
export const GEM_FILES = [
  "pyrite.png",
  "jais.png",
  "nacre.png",
  "ambre.png",
  "corail.png",
  "quartz rose.png",
  "quartz fumé.png",
  "aventurine.png",
  "amazonite.png",
  "cornaline.png",
  "onyx.png",
  "citrine.png",
  "améthyste.png",
  "pierre de lune.png",
  "lapiz lazuli.png",
  "turquoise.png",
  "topaze.png",
  "tourmaline.png",
  "opale.png",
  "aigue-marine.png",
  "jade.png",
  "spinelle.png",
  "péridot.png",
  "tanzanite.png",
  "émeraude.png",
  "saphir.png",
  "rubis.png",
  "diamant.png",
];

/** Pierres considérées comme précieuses (les autres sont communes). */
export const PRECIOUS_GEM_IDS = new Set([
  "spinelle",
  "péridot",
  "tanzanite",
  "émeraude",
  "saphir",
  "rubis",
  "diamant",
]);

export const PRECIOUS_GEMS_TOOLTIP =
  "Spinelle, péridot, tanzanite, émeraude, saphir, rubis et diamant uniquement.";

export function isPreciousGem(gemId) {
  return PRECIOUS_GEM_IDS.has(gemId);
}

export function summarizeGemInventory(counts = {}) {
  let common = 0;
  let precious = 0;

  Object.entries(counts).forEach(([gemId, rawCount]) => {
    const count = Number(rawCount) || 0;
    if (count <= 0) return;
    if (isPreciousGem(gemId)) {
      precious += count;
    } else {
      common += count;
    }
  });

  return { common, precious };
}

const GEM_IMAGE_REGEX = /\.(png|gif|webp|jpe?g|bmp)$/i;

export function isWinVariantFilename(filename) {
  const base = filename.replace(/\.[^.]+$/, "").toLowerCase();
  return base === "win" || base.startsWith("win");
}

export function humanizeGemLabel(filename) {
  const base = filename.replace(/\.[^.]+$/, "");
  const normalized = base
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLocaleLowerCase("fr-FR");

  if (!normalized) return "";

  // Une seule majuscule en tête (ex. « Quartz fumé », « Péridot », « Émeraude »).
  // Ne pas utiliser \b : en JS il ne voit pas les lettres accentuées comme « mot »
  // et provoque des majuscules intempestives (FumÉ, PÉRidot…).
  return normalized.replace(/^(\p{L})/u, (letter) =>
    letter.toLocaleUpperCase("fr-FR")
  );
}

export function buildGemCatalog(filenames = GEM_FILES, counts = {}) {
  const publicUrl = process.env.PUBLIC_URL || "";

  return filenames
    .filter(
      (filename) =>
        typeof filename === "string" &&
        GEM_IMAGE_REGEX.test(filename) &&
        !isWinVariantFilename(filename)
    )
    .map((filename) => {
      const id = filename.replace(/\.[^.]+$/, "");
      return {
        id,
        filename,
        imageUrl: `${publicUrl}/gems/${encodeURIComponent(filename)}`,
        label: humanizeGemLabel(filename),
        count: Number.isFinite(counts[id]) ? counts[id] : 0,
      };
    });
}

export const GEM_COLLECTION_PAGE_COUNT = 2;

export function getGemsForCollectionPage(catalog = [], pageIndex = 0) {
  if (pageIndex === 1) {
    return catalog.filter((gem) => isPreciousGem(gem.id));
  }
  return catalog.filter((gem) => !isPreciousGem(gem.id));
}

export function computeGemCollectionGridColumns(count) {
  if (count <= 0) return 1;
  if (count <= 7) return count;
  return 7;
}
